import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './TripModal.css';
import Aux from '../../hoc/Auxiliary/Auxiliary';
import Backdrop from '../UI/Backdrop/Backdrop';
import carImg from '../../assets/images/car-icon.png';
import carWhiteImg from '../../assets/images/car-white-icon.png';
import archiveImg from '../../assets/images/archive-icon.png';
import deleteImg from '../../assets/images/delete-icon.png';
import closeImg from '../../assets/images/close-icon.png';
import personWhiteImg from '../../assets/images/person-white-icon.png';
import arrowImg from '../../assets/images/arrow-right-icon.png';
import phoneImg from '../../assets/images/phone-icon.png';
import routeIconImg from '../../assets/images/route-white-icon.png';
import sendImg from '../../assets/images/send-white-icon.png';
import axios from '../../axios-trips';
import logError from '../../store/LogError';
import * as actionTypes from '../../store/actions';
import saveImg from '../../assets/images/save-icon.png';
import historyImg from '../../assets/images/history-icon.png';
import placeImg from '../../assets/images/place-white-icon.png';
import telegramImg from '../../assets/images/telegram-icon.png';
import Icon from '../UI/Icon/Icon';
import Button from '../UI/Button/Button';
import ButtonIconConfirm from '../UI/ButtonIconConfirm/ButtonIconConfirm';
import ButtonIcon from '../UI/ButtonIcon/ButtonIcon';
import Input from '../UI/Input/Input';
import Spinner from '../UI/Spinner/Spinner';
import Modal from '../UI/Modal/Modal';
import CarrierModal from '../CarrierModal/CarrierModal';
import TelegramModal from '../TelegramModal/TelegramModal';

class TripModal extends Component {

  createInputConfig = (elementType,
    elementConfig,
    label,
    value = '',
    validation = {},
    valid = true,
    extraClass = null,
    extraAction = null) => {
    return ({
      elementType: elementType,
      elementConfig: elementConfig,
      label: label,
      value: value,
      validation: validation,
      valid: valid,
      extraClass: extraClass,
      extraAction: extraAction,
      touched: false,
      errorMessage: null,
      loading: false
    });
  }

  createLocations() {
    let formattedLocations = [];
    const locations = Object.values(this.props.locations);
    locations.sort(function (a, b) {
      if (a.region > b.region) {
        return 1;
      } else if (a.region === b.region) {
        return a.locationName > b.locationName ? 1 : -1;
      } else {
        return -1;
      }
    });
    locations.forEach(function (obj) {
      formattedLocations.push({ value: obj.id, displayValue: obj.locationName })
    });
    return formattedLocations;
  }

  compareDisplayValue = (a, b) => {
    if (a.displayValue > b.displayValue) {
      return 1;
    } else if (a.displayValue < b.displayValue) {
      return -1;
    }
    return 0;
  }

  openDriverForm = (passDriver = true) => {
    if (passDriver)
      this.props.onShowDriverForm(true, this.state.driverToOpen);
    else
      this.props.onShowDriverForm(true, null);
  }

  deleteDriver = () => {
    if (this.state.driverToOpen) {
      axios({
        method: 'get',
        url: `/api/v1/drivers/delete?driverId=${this.state.driverToOpen.id}`,
        headers: { 'Authorization': 'Bearer ' + this.props.access_token },
      })
        .then(response => {
          this.props.addNotification("Водій успішно видалений", "Success");
        })
        .catch(error => {
          console.log(error.response);
          if (error.response) {
            logError(
              this.props.access_token,
              this.props.codeToMessage[error.response.status],
              '/api/v1/drivers/delete'
            );
            this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
          } else if (!error.response) {
            this.props.addNotification("Помилка на сервері.", "Danger");
          }
        });
    }
  }

  state = {
    localCard: null,
    loading: false,
    showHistory: false,
    history: null,
    carrier: 0,
    driverToOpen: null,
    showCarrier: false,
    showTelegram: false,
    historyLoading: false,
    cardForm: {
      dispatcher: this.createInputConfig(
        'datalist',
        {
          options: [],
          list: 'dispatcher',
          labelClass: classes.LabelInline,
          animate: 0
        },
        'Диспетчер: ',
        '',
        {},
        true,
        null,
        (ev) => this.getUsers(ev)),
      note: this.createInputConfig(
        'textarea',
        {
          placeholder: 'Комментарий...',
          animate: 0
        },
        'Коментар: ',
        '',
        { required: false }),
      tripPoints: this.createInputConfig(
        'trip-points',
        {
          options: [
            ...this.createLocations()
          ],
          animate: 0,
          labelClass: classes.LabelInline,
          buttonImgSrc: routeIconImg
        },
        '',
        [],
        {},
        true,
        null,
        {
          addPoint: (ev) => this.addTripPoint(ev),
          moveUp: (ev, index) => this.moveTripPointUp(ev, index),
          moveDown: (ev, index) => this.moveTripPointDown(ev, index),
          deletePoint: (ev, index) => this.deleteTripPoint(ev, index)
        }
      ),
      tripDate: this.createInputConfig(
        'input',
        {
          type: 'date',
          animate: 0
        },
        'Дата: ',
        '',
        { required: true, type: 'date' },
        true,
        classes.InlineQuarter),
      priority: this.createInputConfig(
        'select',
        {
          options: [
            { value: 'П1', displayValue: 'П1' },
            { value: 'П2', displayValue: 'П2' },
            { value: 'П3', displayValue: 'П3' }
          ],
          animate: 0
        },
        'Пріоритет: ',
        'П3',
        { required: true },
        true,
        classes.Inline15),
      unloadings: this.createInputConfig(
        'dropdown-list',
        {
          options: [],
          buttonImgSrc: placeImg,
          animate: 0
        },
        '',
        'Вивантаження',
        { required: true },
        true,
        classes.InlineInput),
      capacity: this.createInputConfig(
        'input',
        { type: 'number', step: "0.01", min: "0", placeholder: "0", animate: 0 },
        'Вага (тонн): ',
        0,
        { required: true },
        true,
        classes.Inline15),
      capacityFilled: this.createInputConfig(
        'display-only',
        {
          type: 'text',
          animate: 0
        },
        'Заявлено (тонн): ',
        '',
        { required: false },
        true,
        classes.Inline75),
      price: this.createInputConfig(
        'input',
        { type: 'number', step: "0.01", min: "0", placeholder: "0", animate: 0 },
        'Ціна (грн): ',
        0,
        { required: true },
        true,
        classes.InlineQuarter),
      priceComment: this.createInputConfig(
        'input',
        { type: 'text', maxLength: '30', animate: 0 },
        'Ціна Коментар: ',
        '',
        { required: true },
        true,
        classes.InlineQuarter),
      priceConfirmed: this.createInputConfig(
        'toggle-switch',
        { animate: 0 },
        'Ціна Підтверджена: ',
        false,
        { required: false },
        true,
        classes.InlineQuarter),
      telegramMessage: this.createInputConfig(
        'action',
        { animate: 0 },
        '',
        null,
        { required: false },
        true,
        classes.InlineQuarter),
      carrier: this.createInputConfig(
        'input-search',
        {
          options: [],
          animate: 0
        },
        'Перевізник: ',
        '',
        { required: false },
        true,
        classes.InlineInput,
        (ev) => this.getCarriers(ev)),
      carrierConfirmed: this.createInputConfig(
        'toggle-switch',
        { animate: 0 },
        'Договір Укладено: ',
        false,
        { required: false },
        true,
        classes.InlineQuarter),
      carrierAction: this.createInputConfig(
        'action',
        { animate: 0 },
        '',
        null,
        { required: false },
        true,
        classes.InlineQuarter),
      car: this.createInputConfig(
        'cars',
        {
          options: [],
          animate: 0
        },
        'Машина: ',
        '',
        { required: false },
        true,
        classes.InlineInput,
        (ev) => this.createCars(ev)),
      driver: this.createInputConfig(
        'drivers',
        {
          options: [],
          animate: 0,
          labelClass: classes.LabelInline,
        },
        'Водій: ',
        '',
        { required: false },
        true,
        classes.InlineInput,
        {
          create: (ev) => this.createDrivers(ev),
          open: this.openDriverForm,
          delete: this.deleteDriver,
          openNew: (ev) => this.openDriverForm(false)
        }),
      managers: this.createInputConfig(
        'managers',
        { animate: 0 },
        'Менеджери: ',
        [],
        { required: false },
        true,
        null,
        {
          telegramConfirmPrice: (ev) => this.managersConfirmPrice(ev),
          generateTelegramMessage: () => this.generateTelegramMessage()
        }),
      requestsData: this.createInputConfig(
        'requests',
        { animate: 0, editing: false },
        'Заявки: ',
        [],
        { required: false },
        true,
        null,
        {
          openRequest: (ev, key, index) => this.openRequest(ev, key, index),
          createSortingUp: (ev, key, index) => this.createSortingUp(ev, key, index),
          createSortingDown: (ev, key, index) => this.createSortingDown(ev, key, index),
          moveSortingUp: (ev, key, index) => this.moveSortingUp(ev, key, index),
          moveSortingDown: (ev, key, index) => this.moveSortingDown(ev, key, index),
          editing: (ev) => this.requestsEdit(),
          deleteSorting: (ev, index) => this.deleteSorting(ev, index),
          merge: (ev) => this.merge(ev),
          changeSorting: (ev, key, index) => this.changeSorting(ev, key, index)
        })
    }
  }

  changeSorting = (ev, key, index) => {
    const form = { ...this.state.cardForm };
    const newKey = parseInt(ev.target.value, 10);
    if (!(newKey in form.requestsData.value)) {
      form.requestsData.value[newKey] = [];
    }
    form.requestsData.value[newKey].push(form.requestsData.value[key][index]);
    form.requestsData.value[newKey][form.requestsData.value[newKey].length - 1].sorting = newKey;
    form.requestsData.value[key].splice(index, 1);
    this.setState({ cardForm: form });
  }

  merge = (ev, index) => {
    const constructKey = (request) => (request.manager + request.unloading);
    const mergeRequests = (requestsToMerge) => {
      axios({
        method: 'post',
        url: '/api/v1/requests/merge',
        data: requestsToMerge,
        headers: { 'Authorization': 'Bearer ' + this.props.access_token },
      })
        .then(response => {
          this.props.addNotification("Успішно з'єднав заявки " + requestsToMerge.join(","), "Success");
        })
        .catch(error => {
          console.log(error);
          this.setState({ loading: false });
          if (error.response) {
            logError(
              this.props.access_token,
              this.props.codeToMessage[error.response.status],
              '/api/v1/telegram/confirmPrice'
            );
            this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
          }
        });
    };

    const dummyRequestIds = {};
    for (let i = 0; i < this.props.card.requests.length; i++) {
      const key = constructKey(this.props.card.requests[i]);
      if (!(key in dummyRequestIds)) {
        dummyRequestIds[key] = [];
      }
      dummyRequestIds[key].push(this.props.card.requests[i]);
    }

    Object.keys(dummyRequestIds).forEach((items, i) => {
      if (dummyRequestIds[items].length > 1) {
        mergeRequests(dummyRequestIds[items].map(item => item.id));
      }
    });
  }

  requestsEdit = () => {
    const updatedForm = { ...this.state.cardForm };
    updatedForm.requestsData.elementConfig.editing = !updatedForm.requestsData.elementConfig.editing;
    this.setState({ cardForm: updatedForm });
  }

  deleteSorting = (ev, key) => {
    const form = { ...this.state.cardForm };
    const currSortings = Object.keys(form.requestsData.value).sort((a, b) => a - b);
    if (key !== '0') {
      let sort = '0';
      currSortings.forEach(sorting => {
        if (parseInt(sorting) >= parseInt(key) && (parseInt(sorting) + 1) in form.requestsData.value) {
          const requests = [...form.requestsData.value[parseInt(sorting) + 1]];
          requests.forEach(request => request.sorting = parseInt(sorting));
          console.log("Setting " + sorting + " to " + (parseInt(sorting) + 1));
          form.requestsData.value[parseInt(sorting)] = requests;
        }
        sort = sorting;
      });
      delete form.requestsData.value[sort];
      this.setState({ cardForm: form });
    }
  }

  createSortingUp = (ev, key, index) => {
    const form = { ...this.state.cardForm };
    const currSortings = Object.keys(form.requestsData.value).sort((a, b) => a - b);
    if (key !== 0) {
      currSortings.reverse().forEach(sorting => {
        if (parseInt(sorting) >= parseInt(key)) {
          const requests = [...form.requestsData.value[sorting]];
          requests.forEach(request => request.sorting = parseInt(sorting) + 1);
          form.requestsData.value[parseInt(sorting) + 1] = requests;
        }
      });
      form.requestsData.value[parseInt(key)] = [form.requestsData.value[key][index]];
      form.requestsData.value[parseInt(key)][0].sorting = parseInt(key);
      form.requestsData.value[parseInt(key) + 1].splice(index, 1);
      this.setState({ cardForm: form });
    }
  }

  createSortingDown = (ev, key, index) => {
    const form = { ...this.state.cardForm };
    const currSortings = Object.keys(form.requestsData.value).sort((a, b) => a - b);
    currSortings.reverse().forEach(sorting => {
      if (parseInt(sorting) > parseInt(key)) {
        const requests = [...form.requestsData.value[sorting]];
        requests.forEach(request => request.sorting = parseInt(sorting) + 1);
        form.requestsData.value[parseInt(sorting) + 1] = requests;
      }
    });
    form.requestsData.value[parseInt(key) + 1] = [form.requestsData.value[key][index]];
    form.requestsData.value[key][index].sorting = parseInt(key) + 1;
    form.requestsData.value[key].splice(index, 1);
    this.setState({ cardForm: form });
  }

  moveSortingUp = (ev, key, index) => {
    const form = { ...this.state.cardForm };
    const currSortings = Object.keys(form.requestsData.value).sort((a, b) => a - b);
    const updatedRequest = { ...form.requestsData.value[key][index] };
    updatedRequest.sorting = parseInt(key) - 1;
    form.requestsData.value[parseInt(key) - 1].push(updatedRequest);
    form.requestsData.value[key].splice(index, 1);
    this.setState({ cardForm: form });
  }

  moveSortingDown = (ev, key, index) => {
    const form = { ...this.state.cardForm };
    const updatedRequest = { ...form.requestsData.value[key][index] };
    updatedRequest.sorting = parseInt(key) + 1;
    form.requestsData.value[parseInt(key) + 1].push(updatedRequest);
    form.requestsData.value[key].splice(index, 1);
    this.setState({ cardForm: form });
  }

  openRequest(ev, key, index) {
    const myId = this.state.cardForm.requestsData.value[key][index].id;
    let request = null;
    for (let i = 0; i < this.props.card.requests.length; i++) {
      if (parseInt(this.props.card.requests[i].id, 10) === myId) {
        request = { ...this.props.card.requests[i] };
        break;
      }
    }
    if (!request) {
      return;
    }
    let card = {
      id: "R" + request.id,
      index: request.index,
      manager: request.manager,
      weight: request.weight,
      origin: request.origin.locationName,
      destination: request.destination.locationName,
      requestTripDate: request.requestTripDate,
      dateFlexibility: request.dateFlexibility,
      priority: request.priority,
      requestType: request.requestType,
      partialLoad: request.partialLoad,
      tripId: request.tripId,
      initiator: request.initiator,
      unloading: request.unloading,
      unloadAfter: request.unloadAfter,
      moneyRequests: request.moneyRequests
    };

    this.props.onSelectRequest(card);
  }

  addTripPoint(ev) {
    ev.preventDefault();
    const updatedForm = { ...this.state.cardForm };
    const locations = Object.keys(this.props.locations);
    if (locations.length > 0) {
      updatedForm.tripPoints.value.push({
        id: -1,
        tripId: parseInt(this.props.card.id.substring(1, this.props.card.id.length), 10),
        location: this.props.locations[locations[0]]
      }
      );
      updatedForm.tripPoints.elementConfig.animate = updatedForm.tripPoints.elementConfig.animate + 1;
      this.setState({ cardForm: updatedForm });
    } else {
      this.props.addNotification("Не можна додати точку маршруту: немає локацій.", "Danger");
    }
  }

  deleteTripPoint(ev, index) {
    ev.preventDefault();
    const updatedForm = { ...this.state.cardForm };
    updatedForm.tripPoints.value.splice(index, 1);
    updatedForm.tripPoints.elementConfig.animate = updatedForm.tripPoints.elementConfig.animate + 1;
    let capacities = this.getCapacities();
    updatedForm.capacityFilled.value = (
      capacities.map((capacity, index) => {
        return (
          <Aux>
            {this.props.card.tripPoints[index].location.locationName} - {this.props.card.tripPoints[index + 1].location.locationName} {this.roundNum(capacity)} ({this.roundNum(this.props.card.capacity - capacity)})
            <br />
          </Aux>
        )
      })
    );
    this.setState({ cardForm: updatedForm });
  }

  moveTripPointUp(ev, index) {
    ev.preventDefault();
    if (index > 0) {
      const updatedForm = { ...this.state.cardForm };
      const prevPoint = { ...updatedForm.tripPoints.value[index - 1] };
      const currPoint = { ...updatedForm.tripPoints.value[index] };
      updatedForm.tripPoints.value[index - 1] = { ...currPoint, id: prevPoint.id };
      updatedForm.tripPoints.value[index] = { ...prevPoint, id: currPoint.id };
      updatedForm.tripPoints.elementConfig.animate = updatedForm.tripPoints.elementConfig.animate + 1;
      let capacities = this.getCapacities();
      updatedForm.capacityFilled.value = (
        capacities.map((capacity, index) => {
          return (
            <Aux>
              {this.props.card.tripPoints[index].location.locationName} - {this.props.card.tripPoints[index + 1].location.locationName} {this.roundNum(capacity)} ({this.roundNum(this.props.card.capacity - capacity)})
              <br />
            </Aux>
          )
        })
      );
      this.setState({ cardForm: updatedForm });
    }
  }

  moveTripPointDown(ev, index) {
    ev.preventDefault();
    if (index < this.state.cardForm.tripPoints.value.length - 1) {
      const updatedForm = { ...this.state.cardForm };
      const nextPoint = { ...updatedForm.tripPoints.value[index + 1] };
      const currPoint = { ...updatedForm.tripPoints.value[index] };
      updatedForm.tripPoints.value[index + 1] = { ...currPoint, id: nextPoint.id };
      updatedForm.tripPoints.value[index] = { ...nextPoint, id: currPoint.id };
      updatedForm.tripPoints.elementConfig.animate = updatedForm.tripPoints.elementConfig.animate + 1;
      let capacities = this.getCapacities();
      updatedForm.capacityFilled.value = (
        capacities.map((capacity, index) => {
          return (
            <Aux>
              {this.props.card.tripPoints[index].location.locationName} - {this.props.card.tripPoints[index + 1].location.locationName} {this.roundNum(capacity)} ({this.roundNum(this.props.card.capacity - capacity)})
              <br />
            </Aux>
          )
        })
      );
      this.setState({ cardForm: updatedForm });
    }
  }

  generateTelegramMessage() {
    return "#рейс" + this.getId(this.props.card ? this.props.card.id : "0") + " " + this.formatDatePretty(this.props.card ? this.props.card.tripDate : null) + "\n" + this.getTripRoute() + "\n" + (this.props.card && this.props.card.note ? "(" + this.props.card.note + ")\n" : "") + "Ціна: " + this.roundNum(parseFloat(this.state.cardForm.price.value)) + (this.state.cardForm.priceComment.value ? " (за " + this.state.cardForm.capacity.value + " тн; " + this.state.cardForm.priceComment.value + ")" : " (за " + this.state.cardForm.capacity.value + " тн)") + "\nЇдемо?\n(Натисніть # щоб побачити меню)";
  }

  managersConfirmPrice(ev) {
    ev.preventDefault();
    this.updateCard();
    const allManagers = this.state.cardForm.managers.value;
    for (let i = 0; i < allManagers.length; i++) {
      for (let z = 0; z < this.props.card.requests.length; z++) {
        if (this.props.card.requests[z].manager === allManagers[i].manager) {
          if (!this.props.card.requests[z].accepted) {
            this.sendManagerConfirmPrice(allManagers[i]);
            break;
          }
        }
      }
    }
  }

  getTripRoute() {
    if (this.props.card && this.props.card.tripPoints) {
      let routeName = "";
      this.props.card.tripPoints.forEach((tripPoint, index) => {
        if (index < this.props.card.tripPoints.length - 1) {
          routeName += tripPoint.location.locationName + " --> ";
        } else {
          routeName += tripPoint.location.locationName;
        }
      });
      return routeName
    }
    return null;
  }

  sendManagerConfirmPrice(manager) {
    axios({
      method: 'post',
      url: '/api/v1/telegram/confirmPrice',
      data: {
        manager: manager.manager,
        message: this.generateTelegramMessage(),
        tripId: this.props.card.id.substring(1, this.props.card.id.length),
        price: this.roundNum(parseFloat(this.state.cardForm.price.value))
      },
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        console.log(response);
        this.setState({ loading: false });
        if (response.data > -1) {
          this.props.addNotification("Повідомлення " + manager.manager + " відправлено успішно.", "Success");
        } else {
          this.props.addNotification("У менеджера " + manager.manager + " немає ID телеграма.", "Neutral");
        }
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/telegram/confirmPrice'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  compareManagers(a, b) {
    if (a.load < b.load) {
      return 1;
    }
    if (a.load > b.load) {
      return -1;
    }
    return 0;
  }

  getCapacities() {
    let indexedRequests = [];
    for (let i = 0; i < this.props.card.requests.length; i++) {
      let requestOrigin = -1;
      let requestDestination = -1;
      for (let j = 0; j < this.props.card.tripPoints.length; j++) {
        if (requestOrigin === -1 && this.props.card.tripPoints[j].location.locationName === this.props.card.requests[i].origin.locationName) {
          // Request's origin is at tripPoint j
          requestOrigin = j;
        }
        if (this.props.card.tripPoints[j].location.locationName === this.props.card.requests[i].destination.locationName) {
          // Request's destination is at tripPoint j
          requestDestination = j;
        }
      }

      if (requestOrigin !== -1 && requestDestination !== -1 && requestDestination > requestOrigin) {
        indexedRequests.push({ weight: this.props.card.requests[i].weight, origin: requestOrigin, destination: requestDestination });
      }
    }

    let capacities = [];
    for (let i = 0; i < this.props.card.tripPoints.length - 1; i++) {
      let pointCapacity = 0;
      for (let j = 0; j < indexedRequests.length; j++) {
        if (indexedRequests[j].origin < i + 1 && indexedRequests[j].destination > i) {
          pointCapacity += indexedRequests[j].weight;
        }
      }
      capacities.push(pointCapacity);
    }

    return capacities;
  }

  getUniqueUnloadings(requests = null) {
    let unloadings = [];
    let unloadingsTest = [];
    const unloadingRequests = requests ? requests : this.props.card.requests;
    for (let i = 0; i < unloadingRequests.length; i++) {
      let unloading = unloadingRequests[i].sorting !== 0 ? unloadingRequests[i].sorting + " " : "";
      unloading += unloadingRequests[i].destination.locationName
      if (unloadingRequests[i].moneyRequests &&
        unloadingRequests[i].moneyRequests.length > 0 &&
        unloadingRequests[i].moneyRequests[0].unloading) {
        unloading += " " + unloadingRequests[i].moneyRequests[0].unloading;
      } else {
        unloading += unloadingRequests[i].unloading ? ": " + unloadingRequests[i].unloading : "";
      }

      let uniqueUnloading = unloadingRequests[i].sorting !== 0 ? unloadingRequests[i].sorting : unloadingRequests[i].destination.locationName + unloadingRequests[i].unloading;
      if (!unloadingsTest.includes(uniqueUnloading)) {
        unloadingsTest.push(uniqueUnloading);
        unloadings.push({ unloading: unloading, sorting: unloadingRequests[i].sorting });
      }
    }
    unloadings.sort((a, b) => a.sorting - b.sorting);
    return unloadings.map(unloading => unloading.unloading);
  }

  getUnloadingsByDestination() {
    let unloadings = {};
    let uniqueUnloadings = [];
    let unloadingsDuplicates = [];
    for (let i = 0; i < this.props.card.requests.length; i++) {
      let unloading = { location: this.props.card.requests[i].destination.locationName, unloading: this.props.card.requests[i].unloading };
      let unloadingDuplicate = this.props.card.requests[i].destination.locationName + this.props.card.requests[i].unloading;
      if (this.props.card.requests[i].unloading && this.props.card.requests[i].unloading !== "" && !unloadingsDuplicates.includes(unloadingDuplicate)) {
        uniqueUnloadings.push(unloading);
        unloadingsDuplicates.push(unloadingDuplicate);
      }
    }

    for (let i = 0; i < uniqueUnloadings.length; i++) {
      if (uniqueUnloadings[i].location in unloadings) {
        unloadings[uniqueUnloadings[i].location].push(uniqueUnloadings[i].unloading);
      } else {
        unloadings[uniqueUnloadings[i].location] = [uniqueUnloadings[i].unloading];
      }
    }
    console.log("Got unloadings", unloadings);
    return unloadings;
  }

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.props.closeCard();
    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.card && nextProps.card) {
      const updatedCardForm = { ...this.state.cardForm };
      const updateFields = Object.keys(this.state.cardForm);
      updateFields.forEach(field => {
        if (this.props.selectedTrip && field in this.props.selectedTrip && this.props.selectedTrip[field] !== nextProps.selectedTrip[field]) {
          updatedCardForm[field].value = nextProps.card[field];
          updatedCardForm[field].elementConfig.changed = true;
          updatedCardForm[field].elementConfig.animate = updatedCardForm[field].elementConfig.animate + 1;
          if (field === "driver") {
            if (this.state.cardForm.driver.elementConfig.options.length <= 2) {
              this.getDriver(nextProps.card[field]);
            }
          } else if (field === "carrier") {
            if (this.props.carriers.length <= 2) {
              this.getCarrier(nextProps.card[field]);
            }
          } else if (field === "car") {
            this.getCar(nextProps.card.car);
          } else if (field === "tripDate") {
            updatedCardForm[field].value = this.formatDate(nextProps.card[field]);
          }
        }
      });
      this.setState({ cardForm: updatedCardForm });
    }
  }

  sendTelegramMessage = (ev) => {
    ev.preventDefault();
  }

  getUnloadings() {
    let unload = "Вивантаження: ";
    let unloadings = this.getUnloadingsByDestination();
    Object.keys(unloadings).forEach((key, index) => {
      unload += unloadings[key].length + " в " + key;
      if (index < Object.keys(unloadings).length - 1) {
        unload += ", ";
      }
    });
    return unload;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.localCard === null && this.props.card != undefined) {
      const updatedCardForm = { ...this.state.cardForm };
      updatedCardForm.tripDate.value = this.formatDate(this.props.card.tripDate);
      updatedCardForm.tripPoints.elementConfig.options = [...this.createLocations()];
      updatedCardForm.tripPoints.value = this.props.card.tripPoints;
      updatedCardForm.priority.value = this.props.card.priority;
      updatedCardForm.price.value = parseFloat(this.props.card.price).toFixed(2);
      updatedCardForm.priceComment.value = this.props.card.priceComment;
      updatedCardForm.priceConfirmed.value = this.props.card.priceConfirmed;
      updatedCardForm.capacity.value = this.props.card.capacity;
      const unloadings = this.getUniqueUnloadings();
      updatedCardForm.unloadings.elementConfig.options = unloadings;
      updatedCardForm.unloadings.value = " Вивантажень: " + unloadings.length;
      let capacities = this.getCapacities();
      updatedCardForm.capacityFilled.value = (
        capacities.map((capacity, index) => {
          return (
            <Aux>
              {this.props.card.tripPoints[index].location.locationName} - {this.props.card.tripPoints[index + 1].location.locationName} {this.roundNum(capacity)} ({this.roundNum(this.props.card.capacity - capacity)})
              <br />
            </Aux>
          )
        })
      );
      if (this.props.card.car && updatedCardForm.car.elementConfig.options.length <= 2) {
        this.getCar(this.props.card.car);
      }
      updatedCardForm.car.value = this.props.card.car;
      updatedCardForm.carrier.value = this.props.card.carrierId;
      updatedCardForm.carrier.elementConfig.options = this.createCarriers().sort(this.compareDisplayValue);
      if (this.props.role === 'ROLE_ADMIN' || this.props.role === 'ROLE_DISPATCHER' || this.props.role === 'ROLE_RULER') {
        updatedCardForm.carrierAction.value = <ButtonIcon
          btnType='Success'
          disabled={this.state.loading}
          iconClass={classes.ButtonIcon}
          iconSource={personWhiteImg}
          small
          clicked={(ev) => this.setState({ showCarrier: true })}
          iconAlt=''>ВАРІАНТИ</ButtonIcon>;
      }
      if (this.props.role === 'ROLE_ADMIN' || this.props.role === 'ROLE_DISPATCHER') {
        updatedCardForm.carrierAction.value = <ButtonIcon
          btnType='Neutral'
          disabled={this.state.loading}
          iconClass={classes.ButtonIcon}
          iconSource={personWhiteImg}
          small
          clicked={(ev) => this.setState({ showCarrier: true })}
          iconAlt=''>ВАРІАНТИ</ButtonIcon>;
        updatedCardForm.telegramMessage.value = (
          <Aux>
            <ButtonIcon
              btnType='Neutral'
              disabled={this.state.loading}
              iconClass={classes.ButtonIcon}
              iconSource={telegramImg}
              small
              clicked={this.openTelegram}
              iconAlt=''>ТЕЛЕГРАМ</ButtonIcon>
          </Aux>
        );
      }
      updatedCardForm.carrierConfirmed.value = this.props.card.carrierConfirmed;
      if (this.props.card.driver && updatedCardForm.driver.elementConfig.options.length <= 2) {
        this.getDriver(this.props.card.driver);
      } else {
        updatedCardForm.driver.elementConfig.options = this.parseDrivers().sort(this.compareDisplayValue);
        updatedCardForm.driver.value = this.props.card.driver;
      }
      let driverToOpen = null;
      for (let i = 0; i < this.props.drivers.length; i++) {
        if (this.props.drivers[i].id === this.props.card.driver) {
          driverToOpen = this.props.drivers[i];
          break;
        }
      }
      this.setState({ driverToOpen: driverToOpen });
      updatedCardForm.note.value = this.props.card.note;
      updatedCardForm.dispatcher.value = this.props.card.dispatcher;
      const managers = [];
      const managerNames = [];
      const requests = [];
      const managersTbotId = {};
      const managersTbotChatId = {};
      for (let i = 0; i < this.props.card.requests.length; i++) {
        let request = this.props.card.requests[i];
        requests.push({
          id: request.id,
          load: this.roundNum(request.weight),
          archived: request.archived,
          unloadAfter: request.unloadAfter,
          unloading: request.unloading,
          manager: request.manager,
          origin: request.origin.locationName,
          destination: request.destination.locationName,
          moneyRequests: request.moneyRequests,
          sorting: request.sorting
        });
        if (!managerNames.includes(request.manager)) {
          for (let z = 0; z < this.props.managers.length; z++) {
            if (this.props.managers[z].name === request.manager) {
              managersTbotId[request.manager] = this.props.managers[z].tbotId;
              managersTbotChatId[request.manager] = this.props.managers[z].tbotChatId;
              break;
            }
          }
          managerNames.push(request.manager);
          managers.push({
            id: request.id,
            manager: request.manager,
            archived: request.archived,
            initiator: request.initiator,
            load: this.roundNum(request.weight),
            accepted: request.accepted,
            tbotId: managersTbotId[request.manager],
            tbotChatId: managersTbotChatId[request.manager],
            lastMessage: request.managerLastMessage,
            lastMessageDate: request.managerMessageDate,
            lastPrice: request.managerLastPrice
          });
        } else {
          for (let j = 0; j < managers.length; j++) {
            if (managers[j].manager === request.manager) {
              managers[j].load += this.roundNum(request.weight);
              break;
            }
          }
        }
      }
      managers.sort(this.compareManagers);
      updatedCardForm.managers.value = managers;
      const requestBins = { 0: [] };
      for (let i = 0; i < requests.length; i++) {
        if (!(requests[i].sorting in requestBins)) {
          requestBins[requests[i].sorting] = [requests[i]];
        } else {
          requestBins[requests[i].sorting].push(requests[i]);
        }
      }
      const keys = Object.keys(requestBins).sort((a, b) => b - a);
      for (let i = 0; i < keys[0]; i++) {
        if (!(i in requestBins)) {
          requestBins[i] = [];
        }
      }
      updatedCardForm.requestsData.value = requestBins;
      this.setState(
        {
          localCard: { ...this.props.card },
          cardForm: updatedCardForm
        }
      );
      if (this.props.sideBySideMode) {
        this.setState({ showCarrier: false, showTelegram: false });
      }
    }

    if (this.props.card && prevProps.locations !== this.props.locations) {
      const updatedCardForm = { ...this.state.cardForm };
      updatedCardForm.tripPoints.elementConfig.options = [...this.createLocations()];
      this.setState({ localCard: { ...this.props.card }, cardForm: updatedCardForm });
    }

    if (this.props.card && prevProps.card) {
      let same = prevProps.card.tripPoints.length === this.props.card.tripPoints.length;
      if (same) {
        for (let i = 0; i < prevProps.card.tripPoints.length; i++) {
          same = prevProps.card.tripPoints[i].location.id === this.props.card.tripPoints[i].location.id && same;
          if (!same) {
            break;
          }
        }
      }

      if (!same) {
        const updatedCardForm = { ...this.state.cardForm };
        updatedCardForm.tripPoints.value = this.props.card.tripPoints;
        this.setState({ cardForm: updatedCardForm });
      }
    }

    if (this.props.card === null && this.state.localCard !== null) {
      this.setState({ localCard: null });
    }

    if (prevProps.carriers !== this.props.carriers) {
      const updatedCardForm = { ...this.state.cardForm };
      updatedCardForm.carrier.elementConfig.options = this.createCarriers().sort(this.compareDisplayValue);
      this.setState({ cardForm: updatedCardForm });
    }

    if (prevProps.users !== this.props.users) {
      const updatedCardForm = { ...this.state.cardForm };
      updatedCardForm.dispatcher.elementConfig.options = this.createDispatchers().sort(this.compareDisplayValue);
      this.setState({ cardForm: updatedCardForm });
    }

    if (this.state.cardForm.carrier.value !== prevState.cardForm.carrier.value) {
      if (this.state.cardForm.carrier.value !== "-" && this.state.cardForm.carrier.value < 0) {
        for (let i = 0; i < this.props.carriers.length; i++) {
          if (this.state.cardForm.carrier.value === this.props.carriers[i].id) {
            this.props.onShowNewCarrier(this.props.carriers[i]);
            break;
          }
        }
      }
    }

    if (this.props.cars !== prevProps.cars) {
      let cars = [{ value: "-", displayValue: "-" }];
      let foundCar = false;
      for (let i = 0; i < this.props.cars.length; i++) {
        if (this.props.cars[i].name === this.state.cardForm.car.value) {
          foundCar = true;
        }
        if (this.props.cars[i].name) {
          cars.push({
            value: this.props.cars[i].name,
            displayValue: this.props.cars[i].name
          });
        }
      }
      if (!foundCar && this.state.cardForm.car.value !== "-") {
        cars.push({
          value: this.state.cardForm.car.value,
          displayValue: this.state.cardForm.car.value
        });
      }
      const cardForm = { ...this.state.cardForm };
      cardForm.car.elementConfig.options = cars.sort(this.compareDisplayValue);
      this.setState({ loading: false, cardForm: cardForm });
    }

    if (this.props.drivers !== prevProps.drivers) {
      const cardForm = { ...this.state.cardForm };
      let drivers = [{ value: "-", displayValue: "-" }];
      for (let i = 0; i < this.props.drivers.length; i++) {
        drivers.push({
          value: this.props.drivers[i].id,
          displayValue: this.getDriverName(this.props.drivers[i])
        });
      }
      cardForm.driver.elementConfig.options = drivers.sort(this.compareDisplayValue);
      if (this.props.card) {
        cardForm.driver.value = this.props.card.driver;
        let driverToOpen = null;
        for (let i = 0; i < this.props.drivers.length; i++) {
          if (this.props.drivers[i].id === this.props.card.driver) {
            driverToOpen = this.props.drivers[i];
            break;
          }
        }
        this.setState({ driverToOpen: driverToOpen });
      } else {
        cardForm.driver.value = null;
      }
      this.setState({ loading: false, cardForm: cardForm });
    }

    if (this.props.card && prevProps.card && (this.props.card.requests !== prevProps.card.requests)) {
      const updatedCardForm = { ...this.state.cardForm };
      const managers = [];
      const managerNames = [];
      const requests = [];
      const managersTbotId = {};
      const managersTbotChatId = {};
      for (let i = 0; i < this.props.card.requests.length; i++) {
        let request = this.props.card.requests[i];
        requests.push({
          id: request.id,
          load: this.roundNum(request.weight),
          archived: request.archived,
          unloadAfter: request.unloadAfter,
          unloading: request.unloading,
          manager: request.manager,
          origin: request.origin.locationName,
          destination: request.destination.locationName,
          moneyRequests: request.moneyRequests,
          sorting: request.sorting
        });
        if (!managerNames.includes(request.manager)) {
          for (let z = 0; z < this.props.managers.length; z++) {
            if (this.props.managers[z].name === request.manager) {
              managersTbotId[request.manager] = this.props.managers[z].tbotId;
              managersTbotChatId[request.manager] = this.props.managers[z].tbotChatId;
              break;
            }
          }
          managerNames.push(request.manager);
          managers.push({
            id: request.id,
            manager: request.manager,
            archived: request.archived,
            initiator: request.initiator,
            load: this.roundNum(request.weight),
            accepted: request.accepted,
            tbotId: managersTbotId[request.manager],
            tbotChatId: managersTbotChatId[request.manager],
            lastMessage: request.managerLastMessage,
            lastMessageDate: request.managerMessageDate,
            lastPrice: request.managerLastPrice
          });
        } else {
          for (let j = 0; j < managers.length; j++) {
            if (managers[j].manager === request.manager) {
              managers[j].load += this.roundNum(request.weight);
              break;
            }
          }
        }
      }
      managers.sort(this.compareManagers);
      updatedCardForm.managers.value = managers;
      let capacities = this.getCapacities();
      updatedCardForm.capacityFilled.value = (
        capacities.map((capacity, index) => {
          return (
            <Aux>
              {this.props.card.tripPoints[index].location.locationName} - {this.props.card.tripPoints[index + 1].location.locationName} {this.roundNum(capacity)} ({this.roundNum(this.props.card.capacity - capacity)})
              <br />
            </Aux>
          )
        })
      );
      const requestBins = { 0: [] };
      for (let i = 0; i < requests.length; i++) {
        if (!(requests[i].sorting in requestBins)) {
          requestBins[requests[i].sorting] = [requests[i]];
        } else {
          requestBins[requests[i].sorting].push(requests[i]);
        }
      }
      const keys = Object.keys(requestBins).sort((a, b) => b - a);
      for (let i = 0; i < keys[0]; i++) {
        if (!(i in requestBins)) {
          requestBins[i] = [];
        }
      }
      updatedCardForm.requestsData.value = requestBins;
      const unloadings = this.getUniqueUnloadings();
      updatedCardForm.unloadings.elementConfig.options = unloadings;
      this.setState({ cardForm: updatedCardForm });
    }

    if (this.props.card && prevProps.card && (this.props.managers !== prevProps.managers)) {
      const updatedCardForm = { ...this.state.cardForm };
      const managers = [];
      const managerNames = [];
      const requests = [];
      const managersTbotId = {};
      const managersTbotChatId = {};
      for (let i = 0; i < this.props.card.requests.length; i++) {
        let request = this.props.card.requests[i];
        requests.push({
          id: request.id,
          load: this.roundNum(request.weight),
          unloadAfter: request.unloadAfter,
          archived: request.archived,
          unloading: request.unloading,
          manager: request.manager,
          origin: request.origin.locationName,
          destination: request.destination.locationName,
          moneyRequests: request.moneyRequests,
          sorting: request.sorting
        });
        if (!managerNames.includes(request.manager)) {
          for (let z = 0; z < this.props.managers.length; z++) {
            if (this.props.managers[z].name === request.manager) {
              managersTbotId[request.manager] = this.props.managers[z].tbotId;
              managersTbotChatId[request.manager] = this.props.managers[z].tbotChatId;
              break;
            }
          }
          managerNames.push(request.manager);
          managers.push({
            id: request.id,
            manager: request.manager,
            archived: request.archived,
            initiator: request.initiator,
            load: this.roundNum(request.weight),
            accepted: request.accepted,
            tbotId: managersTbotId[request.manager],
            tbotChatId: managersTbotChatId[request.manager],
            lastMessage: request.managerLastMessage,
            lastMessageDate: request.managerMessageDate,
            lastPrice: request.managerLastPrice
          });
        } else {
          for (let j = 0; j < managers.length; j++) {
            if (managers[j].manager === request.manager) {
              managers[j].load += this.roundNum(request.weight);
              break;
            }
          }
        }
      }
      managers.sort(this.compareManagers);
      updatedCardForm.managers.value = managers;
      let capacities = this.getCapacities();
      updatedCardForm.capacityFilled.value = (
        capacities.map((capacity, index) => {
          return (
            <Aux>
              {this.props.card.tripPoints[index].location.locationName} - {this.props.card.tripPoints[index + 1].location.locationName} {this.roundNum(capacity)} ({this.roundNum(this.props.card.capacity - capacity)})
              <br />
            </Aux>
          )
        })
      );
      const requestBins = { 0: [] };
      for (let i = 0; i < requests.length; i++) {
        if (!(requests[i].sorting in requestBins)) {
          requestBins[requests[i].sorting] = [requests[i]];
        } else {
          requestBins[requests[i].sorting].push(requests[i]);
        }
      }

      const keys = Object.keys(requestBins).sort((a, b) => b - a);
      for (let i = 0; i < keys[0]; i++) {
        if (!(i in requestBins)) {
          requestBins[i] = [];
        }
      }
      updatedCardForm.requestsData.value = requestBins;
      this.setState({ cardForm: updatedCardForm });
    }
  }

  getDriverName(driver) {
    if (!driver) return "";
    return driver.name + " | " + driver.phone + " | " + driver.license + " | " + driver.comment;
  }

  getCar(car) {
    const updatedCardForm = { ...this.state.cardForm };
    updatedCardForm.car.elementConfig.options = [{ value: car, displayValue: car }];
    this.setState({ cardForm: updatedCardForm });
  }

  getDriver(driverId) {
    axios({
      method: 'get',
      url: '/api/v1/drivers/driver?id=' + driverId,
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        const updatedForm = { ...this.state.cardForm };
        updatedForm.driver.elementConfig.options = [
          {
            value: response.data.id,
            displayValue: this.getDriverName(response.data),
            phone: response.data.phone
          }
        ];
        updatedForm.driver.value = response.data.id;
        this.setState({ driverToOpen: response.data });
        this.setState({ cardForm: updatedForm });
      })
      .catch(error => {
        console.log(error.response);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/drivers/driver?id=' + driverId
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Ошибка на сервере.", "Danger");
        }
      });
  }

  getAttribute(carrier, attr) {
    if (carrier[attr]) {
      return carrier[attr];
    }
    return "";
  }

  getCarrier(carrierId) {
    axios({
      method: 'get',
      url: '/api/v1/carriers/carrier?id=' + carrierId,
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        const updatedForm = { ...this.state.cardForm };
        let carrierName = response.data.id <= 0 ? " " : response.data.id + " | ";
        carrierName += this.getAttribute(response.data, "okpo") + " | ";
        carrierName += this.getAttribute(response.data, "name") + " | ";
        carrierName += this.getAttribute(response.data, "name_partner") + " | ";
        carrierName += this.getAttribute(response.data, "name_ls");
        const updatedOptions = [{ value: "-", displayValue: "-" }];
        updatedOptions.push({ value: response.data.id, displayValue: carrierName });
        updatedForm.carrier.elementConfig.options = updatedOptions;
        updatedForm.carrier.value = response.data.id;
        this.setState({ cardForm: updatedForm });
      })
      .catch(error => {
        console.log(error.response);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/carriers/carrier?id=' + carrierId
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Ошибка на сервере.", "Danger");
        }
      });
  }

  createCarriers() {
    let carriers = [];
    carriers.push({ value: "-", displayValue: "-" });
    let foundCarrier = false;
    for (let i = 0; i < this.props.carriers.length; i++) {
      let carrier = this.props.carriers[i];
      let carrierName = carrier.id <= 0 ? " " : carrier.id + " | ";
      carrierName += this.getAttribute(carrier, "okpo") + " | ";
      carrierName += this.getAttribute(carrier, "name") + " | ";
      carrierName += this.getAttribute(carrier, "name_partner") + " | ";
      carrierName += this.getAttribute(carrier, "name_ls");
      carriers.push({
        value: carrier.id,
        displayValue: carrierName
      });
      foundCarrier = foundCarrier || (this.props.card && carrier.id === this.props.card.carrierId);
    }
    if (!foundCarrier && this.props.card && this.props.card.carrierId) {
      this.getCarrier(this.props.card.carrierId);
    }
    return carriers;
  }

  createDispatchers() {
    let dispatchers = [];
    dispatchers.push({ value: "-", displayValue: "-" });
    for (let i = 0; i < this.props.users.length; i++) {
      dispatchers.push({
        value: this.props.users[i],
        displayValue: this.props.users[i]
      });
    }
    return dispatchers;
  }

  createManagers() {
    return this.props.managers.map((manager, index) => {
      return (
        { value: manager.name, displayValue: manager.name }
      )
    });
  }

  updateLoading = (attr, loading) => {
    const updatedCarriers = { ...this.state.cardForm };
    updatedCarriers[attr].loading = loading;
    this.setState({ cardForm: updatedCarriers });
  }

  getCarriers() {
    if (this.state.cardForm.carrier.loading) {
      return;
    }

    this.updateLoading("carrier", true);
    axios({
      method: 'get',
      url: '/api/v1/carriers',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        this.updateLoading("carrier", false);
        if (this.props.carriers.length !== response.data.length) {
          const carriers = [...response.data];
          let negId = -1;
          for (let i = 0; i < carriers.length; i++) {
            if (!carriers[i].id) {
              carriers[i].id = negId;
              negId -= 1;
            }
          }
          this.props.onSetCarriers(carriers);
        }
      })
      .catch(error => {
        this.updateLoading("carrier", false);
        console.log(error.response);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/carriers'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Сервер не відповідає.", "Danger");
        }
      });
  }

  getUsers() {
    if (this.state.cardForm.dispatcher.loading) {
      return;
    }

    this.updateLoading("dispatcher", true);
    axios({
      method: 'get',
      url: '/api/v1/users',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        this.updateLoading("dispatcher", false);
        if (this.props.users.length !== response.data.length) {
          let parsedUsers = [];
          for (let i = 0; i < response.data.length; i++) {
            parsedUsers.push(response.data[i].substring(0, response.data[i].indexOf('@')));
          }
          this.props.onSetUsers(parsedUsers);
        }
      })
      .catch(error => {
        this.updateLoading("dispatcher", false);
        console.log(error.response);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/users'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Ошибка на сервере.", "Danger");
        }
      });
  }

  createCars() {
    if (this.state.cardForm.car.loading) {
      return;
    }

    this.updateLoading("car", true);
    if (this.props.cars.length <= 2) {
      axios({
        method: 'get',
        url: '/api/v1/cars',
        headers: { 'Authorization': 'Bearer ' + this.props.access_token },
      })
        .then(response => {
          this.updateLoading("car", false);
          this.props.onSetCars(response.data);
        })
        .catch(error => {
          this.updateLoading("car", false);
          console.log(error.response);
          if (error.response) {
            logError(
              this.props.access_token,
              this.props.codeToMessage[error.response.status],
              '/api/v1/cars'
            );
            this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
          } else if (!error.response) {
            this.props.addNotification("Помилка на сервері.", "Danger");
          }
        });
    }
  }

  parseDrivers() {
    return this.props.drivers.filter(driver => (driver.id && driver.name)).map(driver => (
      { value: driver.id, displayValue: this.getDriverName(driver), phone: driver.phone }
    ));
  }

  createDrivers() {
    if (this.state.cardForm.driver.loading) {
      return;
    }

    this.updateLoading("driver", true);
    if (this.props.drivers.length <= 2) {
      axios({
        method: 'get',
        url: '/api/v1/drivers',
        headers: { 'Authorization': 'Bearer ' + this.props.access_token },
      })
        .then(response => {
          this.updateLoading("driver", false);
          this.props.onSetDrivers(response.data);
        })
        .catch(error => {
          this.updateLoading("driver", false);
          console.log(error.response);
          if (error.response) {
            logError(
              this.props.access_token,
              this.props.codeToMessage[error.response.status],
              '/api/v1/drivers'
            );
            this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
          } else if (!error.response) {
            this.props.addNotification("Ошибка на сервере.", "Danger");
          }
        });
    }
  }

  formatDate(date) {
    if (date === undefined || date === null) {
      return null;
    }
    return date.substring(0, 10);
  }

  transformDate(date) {
    if (date === undefined || date === null) {
      return null;
    }
    return date.substring(6, 10) + "-" + date.substring(3, 5) + "-" + date.substring(0, 2);
  }

  formatDatePretty(date) {
    if (date === undefined || date === null) {
      return null;
    }
    return date.substring(8, 10) + "/" + date.substring(5, 7) + "/" + date.substring(2, 4);
  }

  roundNum(num) {
    return Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100;
  }

  checkValidity(value, rules) {
    let isValid = true;

    if (rules.required) {
      isValid = value.trim !== '' && isValid;
    }

    if (rules.type === 'email') {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      isValid = re.test(value) && isValid;
    }

    if (rules.type == 'confirmPassword') {
      isValid = this.state.registerForm.password.value === value && isValid;
    }

    if (rules.minLength) {
      isValid = value.length >= rules.minLength && isValid;
    }

    if (rules.maxLength) {
      isValid = value.length <= rules.maxLength && isValid;
    }

    return isValid;
  }

  getErrorMessage(value, rules) {
    let errorMessage = '';

    if (rules.required && value.trim === '') {
      errorMessage = 'Це поле обов\'язкове';
    }

    if (rules.type == 'email') {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(value)) {
        errorMessage = 'Введіть пошту';
      }
    }

    if (rules.type == 'confirmPassword' && this.state.registerForm.password.value !== value) {
      errorMessage = 'Паролі повинні співпадати';
    }

    if (rules.minLength && value.length < rules.minLength) {
      errorMessage = 'Мінімальна довжина: ' + rules.minLength;
    }

    if (rules.maxLength && value.length > rules.maxLength) {
      errorMessage = 'Максимальна довжина: ' + rules.minLength;
    }

    return errorMessage;
  }

  inputChangedHandler = (event, elementId) => {
    const updatedOrderForm = {
      ...this.state.cardForm
    }
    const updatedFormElement = {
      ...updatedOrderForm[elementId]
    }

    if ((event.target.value === '' || event.target.value === null) &&
      updatedOrderForm[elementId].elementConfig.type === 'number') {
      event.target.value = 0;
    }

    if (updatedOrderForm[elementId].elementConfig.type === 'number') {
      event.target.value = Math.round((parseFloat(event.target.value) + Number.EPSILON) * 100) / 100;
    }
    if (elementId === 'car' && event.target.value !== "-") {
      if (!event.target.exist) {
        this.props.onSetCars([...this.props.cars, { name: event.target.value }]);
      }
    } else if (elementId === 'driver') {
      let driverToOpen = null;
      for (let i = 0; i < this.props.drivers.length; i++) {
        if (this.props.drivers[i].id === event.target.value) {
          driverToOpen = this.props.drivers[i];
          break;
        }
      }
      this.setState({ driverToOpen: driverToOpen });
    }
    updatedFormElement.value = event.target.value;
    updatedOrderForm[elementId] = updatedFormElement;
    let capacities = this.getCapacities();
    updatedOrderForm.capacityFilled.value = (
      capacities.map((capacity, index) => {
        return (
          <Aux>
            {this.props.card.tripPoints[index].location.locationName} - {this.props.card.tripPoints[index + 1].location.locationName} {this.roundNum(capacity)} ({this.roundNum(this.props.card.capacity - capacity)})
            <br />
          </Aux>
        )
      })
    );
    const updatedCard = { ...this.state.localCard };
    updatedCard[elementId] = event.target.value;
    this.setState({ cardForm: updatedOrderForm, localCard: updatedCard });
  }

  removeElementHandler = (element, arrayProperty, property) => {
    const updatedCard = { ...this.state.localCard };
    let foundIndex = -1;
    for (let i = 0; i < updatedCard[arrayProperty].length; i++) {
      if (updatedCard[arrayProperty][i][property] === element) {
        foundIndex = i;
      }
    }
    updatedCard[arrayProperty].splice(foundIndex, 1);
    this.setState({ localCard: updatedCard });
  }

  updateCard = (archived = null) => {
    const cardForm = { ...this.state.cardForm };
    const requestsSortings = Object.keys(cardForm.requestsData.value);
    const requests = [];
    for (let i = 0; i < requestsSortings.length; i++) {
      for (let j = 0; j < cardForm.requestsData.value[requestsSortings[i]].length; j++) {
        requests.push(cardForm.requestsData.value[requestsSortings[i]][j]);
      }
    }
    const destinations = [];
    let index = 1;
    for (let i = 0; i < requests.length; i++) {
      if (!destinations.includes(requests[i].destination)) {
        destinations.push(requests[i].destination);
        if (index >= this.state.cardForm.tripPoints.value.length ||
          this.state.cardForm.tripPoints.value[index].location.id !== this.props.locations[requests[i].destination].id) {
          this.props.addNotification("Вивантаження в заявках не відповідають маршруту рейсу.", "Danger");
          break;
        }
        index += 1;
      }
    }

    let archivedTrip = this.props.card.archived ? this.props.card.archived : false;
    let localRequests = [];
    this.props.requests.forEach(request => {
      if (request.tripId === parseInt(this.props.card.id.substring(1, this.props.card.id.length), 10)) {
        localRequests.push({ ...request });
      }
    });
    const trip = {
      id: this.props.card.id.substring(1, this.props.card.id.length),
      tripDate: this.state.cardForm.tripDate.value + "T00:00:00",
      tripPoints: this.state.cardForm.tripPoints.value,
      price: parseFloat(this.state.cardForm.price.value),
      priceComment: this.state.cardForm.priceComment.value,
      priceConfirmed: this.state.cardForm.priceConfirmed.value,
      capacity: this.state.cardForm.capacity.value,
      priority: this.state.cardForm.priority.value,
      carrier: this.state.cardForm.carrier.value,
      carrierConfirmed: this.state.cardForm.carrierConfirmed.value,
      car: this.state.cardForm.car.value,
      driver: this.state.cardForm.driver.value,
      dispatcher: this.state.cardForm.dispatcher.value,
      requests: localRequests,
      note: this.state.cardForm.note.value,
      archived: (archived || archived === false) ? archived : archivedTrip
    }

    this.setState({ loading: true });
    axios({
      method: 'post',
      url: '/api/v1/trips/update',
      data: trip,
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        console.log(response);
        this.props.addNotification("Рейс збережено успішно.", "Success");

        const updatedCardForm = { ...this.state.cardForm };
        updatedCardForm.tripDate.value = this.formatDate(response.data.tripDate);
        this.setState({ loading: false, carrier: response.data.carrier, cardForm: updatedCardForm });

        if (archived) {
          this.onCardDeleteHandler(this.props.card.id.substring(1, this.props.card.id.length));
          this.props.closeCard();
        } else {
          this.onRouteUpdateHandler(response.data);
        }
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/trips/update'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });

    this.updateRequests((archived || archived === false) ? archived : archivedTrip);
  }

  updateRequests(archived) {
    const updatedRequests = [...this.props.requests];
    let oldRequest = null;
    let newRequest = null;
    let requestsToUpdate = [];
    for (let i = 0; i < updatedRequests.length; i++) {
      oldRequest = updatedRequests[i];
      let updatedRequest = false;
      for (let j = 0; j < this.state.cardForm.managers.value.length; j++) {
        newRequest = this.state.cardForm.managers.value[j];
        if (parseInt(newRequest.id) === parseInt(oldRequest.id)) {
          newRequest.archived = archived;
          if (oldRequest.initiator !== newRequest.initiator ||
            oldRequest.accepted !== newRequest.accepted ||
            oldRequest.sorting !== newRequest.sorting) {
            requestsToUpdate.push({
              ...oldRequest,
              initiator: newRequest.initiator,
              accepted: newRequest.accepted,
              archived: newRequest.archived,
              sorting: newRequest.sorting
            });
            updatedRequests[i].initiator = newRequest.initiator;
            updatedRequests[i].accepted = newRequest.accepted;
            updatedRequests[i].sorting = newRequest.sorting;
            updatedRequest = true;
          }
        }
      }

      const allRequests = [];
      Object.keys(this.state.cardForm.requestsData.value).forEach(key => {
        this.state.cardForm.requestsData.value[key].forEach(request => {
          allRequests.push({ ...request });
        })
      });

      for (let j = 0; j < allRequests.length; j++) {
        newRequest = allRequests[j];
        if (parseInt(newRequest.id) === parseInt(oldRequest.id)) {
          if (oldRequest.weight !== newRequest.load ||
            oldRequest.unloadAfter !== newRequest.unloadAfter ||
            oldRequest.sorting !== newRequest.sorting) {
            if (updatedRequest) {
              requestsToUpdate[requestsToUpdate.length - 1].weight = this.roundNum(newRequest.load);
              requestsToUpdate[requestsToUpdate.length - 1].unloadAfter = newRequest.unloadAfter;
              requestsToUpdate[requestsToUpdate.length - 1].sorting = newRequest.sorting;
            } else {
              requestsToUpdate.push({
                ...oldRequest,
                weight: this.roundNum(newRequest.load),
                unloadAfter: newRequest.unloadAfter,
                sorting: newRequest.sorting
              });
            }
            updatedRequests[i].weight = this.roundNum(newRequest.load);
            updatedRequests[i].unloadAfter = newRequest.unloadAfter;
            updatedRequests[i].sorting = newRequest.sorting;
          }
          break;
        }
      }
    }

    axios({
      method: 'post',
      url: '/api/v1/requests/updateAll',
      data: requestsToUpdate,
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        console.log(response);
        this.setState({ loading: false });
        this.props.addNotification("Заявки оновлено успішно.", "Success");
        this.props.onSetRequests([...updatedRequests]);
        const updatedForm = { ...this.state.cardForm };
        const unloadings = this.getUniqueUnloadings([...updatedRequests].filter(el => el.tripId === parseInt(this.props.card.id.substring(1, this.props.card.id.length), 10)));
        updatedForm.unloadings.elementConfig.options = unloadings;
        this.setState({ cardForm: updatedForm });
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/requests/updateAll'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  onRouteUpdateHandler(trip) {
    const updatedRoutes = [...this.props.routes];
    let index = -1;
    for (let i = 0; i < updatedRoutes.length; i++) {
      if (parseInt(updatedRoutes[i].id) === parseInt(trip.id)) {
        index = i;
        break;
      }
    }

    if (index !== -1) {
      updatedRoutes[index] = trip;
      this.props.onSetRoutes(updatedRoutes);
    } else {
      console.log("Something went wrong. Invalid index for trip update.");
    }
  }

  deleteCard = () => {
    this.setState({ loading: true });
    axios({
      method: 'post',
      url: '/api/v1/trips/delete?id=' + this.props.card.id.substring(1, this.props.card.id.length),
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        console.log(response);
        this.props.addNotification("Рейс був успішно видалений.", "Success");
        this.setState({ loading: false });
        this.onCardDeleteHandler(this.props.card.id.substring(1, this.props.card.id.length));
        this.props.closeCard();
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/trips/delete?id=' + this.props.card.id.substring(1, this.props.card.id.length)
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  onCardDeleteHandler(cardId) {
    const updatedRoutes = [...this.props.routes];
    let index = -1;
    cardId = parseInt(cardId);
    for (let i = 0; i < updatedRoutes.length; i++) {
      if (parseInt(updatedRoutes[i].id) === parseInt(cardId)) {
        index = i;
        break;
      }
    }

    if (index !== -1) {
      updatedRoutes.splice(index, 1);
      this.props.onSetRoutes(updatedRoutes);
      console.log("Updated routes");
    } else {
      console.log("Something went wrong when deleting trip: invalid index");
    }
  }

  importToTripTracking = () => {
    this.setState({ loading: true });
    axios({
      method: 'post',
      url: '/api/v1/trips/import-to-trip-track?id=' + this.props.card.id.substring(1, this.props.card.id.length),
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        console.log(response);
        this.props.addNotification("Рейс успішно доданий в перевезення.", "Success");
        this.setState({ loading: false });
        this.props.closeCard();
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/trips/delete?id=' + this.props.card.id.substring(1, this.props.card.id.length)
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  openHistory = (event) => {
    event.preventDefault();
    if (this.props.card.id.substring(1, this.props.card.id.length)) {
      this.setState({ showHistory: true, historyLoading: true });
      axios({
        method: 'get',
        url: '/api/v1/history?id=' + this.props.card.id.substring(1, this.props.card.id.length),
        headers: { 'Authorization': 'Bearer ' + this.props.access_token },
      })
        .then(response => {
          console.log(response);
          this.setState({ historyLoading: false, history: response.data });
        })
        .catch(error => {
          console.log(error);
          this.setState({ historyLoading: false });
          if (error.response) {
            logError(
              this.props.access_token,
              this.props.codeToMessage[error.response.status],
              '/api/v1/history?id=' + this.props.card.id.substring(1, this.props.card.id.length)
            );
            this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
          }
        });
    }
  }

  parseHistoryDate = (historyDate) => {
    return historyDate.substring(8, 10) + "/" + historyDate.substring(5, 7) + " " + historyDate.substring(11, 16);
  }

  parseHistoryChange = (hist) => {
    let historyChange = this.parseHistoryDate(hist.changeDate) + " - ";
    historyChange += hist.changeMessage;
    return historyChange;
  }

  getId(id) {
    id = parseInt(id.substring(1, id.length));
    if (id < 10) {
      return "00" + id;
    } if (id < 100) {
      return "0" + id;
    }

    if (id.length == 3) {
      return id;
    } else {
      return id.toString().substring(id.toString().length - 3, id.toString().length);
    }
  }

  openTelegram = () => {
    if (this.props.managers.length < 2) {
      axios({
        method: 'get',
        url: '/api/v1/managers',
        headers: { 'Authorization': 'Bearer ' + this.props.access_token },
      })
        .then(response => {
          this.props.onSetManagers(response.data);
          this.setState({ showTelegram: true });
        })
        .catch(error => {
          console.log(error.response);
          if (error.response) {
            logError(
              this.props.access_token,
              this.props.codeToMessage[error.response.status],
              '/api/v1/managers'
            );
            this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
          } else if (!error.response) {
            this.props.addNotification("Помилка на сервері.", "Danger");
          }
        });
    } else {
      this.setState({ showTelegram: true });
    }
  }

  render() {
    let show = true;
    let card = null;

    if (this.state.localCard === null) {
      card = null;
      show = false;
    } else {

      const cardFormArray = [];
      for (let key in this.state.cardForm) {
        cardFormArray.push({ id: key, config: this.state.cardForm[key] });
      }

      let loading = null;
      if (this.state.loading) {
        loading = (
          <Spinner />
        )
      }

      let history = null;
      if (this.state.history) {
        history = (
          <ul className={classes.HistoryList}>
            {
              this.state.history.map((hist) => {
                return (
                  <li className={classes.HistoryEntry}>
                    {this.parseHistoryChange(hist)}
                  </li>
                )
              })
            }
          </ul>
        );
      }

      let headerClasses = [classes.Header];
      if (this.state.cardForm.carrierConfirmed.value) {
        headerClasses.push(classes.HeaderBrightGreen);
      } else if (this.state.cardForm.priceConfirmed.value) {
        headerClasses.push(classes.HeaderLightGreen);
      } else if (parseFloat(this.state.cardForm.price.value) === 0) {
        headerClasses.push(classes.HeaderWhite);
      } else {
        headerClasses.push(classes.HeaderOrange);
      }

      let routeHeading = null;
      if (this.state.cardForm.tripPoints.value) {
        routeHeading = (
          this.state.cardForm.tripPoints.value.map((tripPoint, index) => {
            return (
              <Aux>
                {
                  index < this.state.cardForm.tripPoints.value.length - 1 ?
                    <Aux>
                      <p>{tripPoint.location.locationName}</p>
                      <Icon iconClass={classes.ArrowIcon} iconSource={arrowImg} iconAlt='' className={classes.CardIcon} />
                    </Aux>
                    :
                    <Aux>
                      <p>{tripPoint.location.locationName}</p>
                    </Aux>
                }
              </Aux>
            );
          })
        );
      }

      let footerButtons = null;
      if (this.props.role === 'ROLE_MANAGER' || this.props.role === 'ROLE_RULER') {
        footerButtons = (
          <Aux>
            <ButtonIcon
              btnType='Success'
              disabled={this.state.loading}
              iconClass={classes.ButtonIcon}
              iconSource={historyImg}
              small
              clicked={(ev) => this.openHistory(ev)}
              iconAlt=''>ІСТОРІЯ</ButtonIcon>
          </Aux>
        );
      } else if (this.props.role === 'ROLE_ADMIN' || this.props.role === 'ROLE_DISPATCHER') {
        footerButtons = (
          <Aux>
            <ButtonIcon
              btnType='Success'
              clicked={() => this.updateCard(false)}
              disabled={this.state.loading}
              iconClass={classes.ButtonIcon}
              iconSource={saveImg}
              small
              iconAlt=''>ЗБЕРЕГТИ</ButtonIcon>
            <ButtonIcon
              btnType='Success'
              disabled={this.state.loading}
              iconClass={classes.ButtonIcon}
              iconSource={historyImg}
              small
              clicked={(ev) => this.openHistory(ev)}
              iconAlt=''>ІСТОРІЯ</ButtonIcon>
            <ButtonIconConfirm
              btnType='Danger'
              disabled={this.state.loading}
              iconClass={classes.ButtonIcon}
              iconSource={deleteImg}
              small
              iconAlt=''
              clicked={this.deleteCard}
              confirmText='видалити Рейс'>ВИДАЛИТИ</ButtonIconConfirm>
            {
              this.props.card && !this.props.card.archived ?
                <ButtonIconConfirm
                  btnType='Success'
                  disabled={this.state.loading}
                  iconClass={classes.ButtonIcon}
                  iconSource={archiveImg}
                  iconAlt=''
                  small
                  clicked={() => this.updateCard(true)}
                  confirmText='архівувати Рейс'>АРХІВУВАТИ</ButtonIconConfirm>
                :
                <ButtonIconConfirm
                  btnType='Neutral'
                  disabled={this.state.loading}
                  iconClass={classes.ButtonIcon}
                  iconSource={archiveImg}
                  iconAlt=''
                  small
                  clicked={() => this.updateCard(false)}
                  confirmText='розархівувати Рейс'>РОЗАРХІВУВАТИ</ButtonIconConfirm>
            }

            {
              this.props.card && this.props.card.tripPoints[0].location.region === 7 &&
              <ButtonIconConfirm
                btnType='Success'
                disabled={this.state.loading}
                iconClass={classes.ButtonIcon}
                iconSource={carWhiteImg}
                iconAlt=''
                small
                clicked={() => this.importToTripTracking()}
                confirmText='додати Рейс в відстеження та архівувати'>
                В ВІДСТЕЖЕННЯ
              </ButtonIconConfirm>
            }
          </Aux>
        );
      }

      card = (
        <Aux>
          <Modal
            loading={this.state.historyLoading}
            show={this.state.showHistory}
            modalClosed={() => this.setState({ showHistory: false })} >
            <div className={classes.HistoryHolder}>

              {history}

              <div className={classes.HistoryFooter}>
                <Button
                  btnType={['Success', 'NoMargin']}
                  clicked={() => this.setState({ showHistory: false })}>
                  ЗАКРИТИ
                </Button>
              </div>
            </div>
          </Modal>

          <CarrierModal
            card={this.state.showCarrier && this.props.card ? { trip: this.props.card.id, carrier: this.state.cardForm.carrier.value, driver: this.state.cardForm.driver.value } : null}
            name="Перевізники"
            closeCard={(ev) => this.setState({ showCarrier: false })}></CarrierModal>

          <TelegramModal
            updateCard={this.updateCard}
            card={
              this.state.showTelegram && this.props.card ?
                {
                  id: this.props.card.id.substring(1, this.props.card.id.length),
                  date: this.formatDatePretty(this.props.card.tripDate),
                  capacity: this.props.card.capacity,
                  unloadings: this.getUnloadingsByDestination(),
                  tripPoints: this.props.card.tripPoints,
                  price: this.roundNum(parseFloat(this.state.cardForm.price.value)),
                  managers: this.state.cardForm.managers.value,
                  carrierConfirmed: this.state.cardForm.carrierConfirmed.value
                }
                : null
            }
            name="Перевізники"
            closeCard={(ev) => this.setState({ showTelegram: false })}></TelegramModal>

          <div className={headerClasses.join(' ')}>

            <div className={classes.TripTitle}>
              <Icon iconClass={classes.CarIcon} iconSource={carImg} iconAlt='' className={classes.CardIcon} />
              <p>{this.props.card ? this.getId(this.props.card.id) : null}.&nbsp;</p>
              {routeHeading}
            </div>

            <button className={classes.CloseButton} onClick={this.props.closeCard}>
              <Icon iconClass={classes.CloseIcon} iconSource={closeImg} iconAlt='' />
            </button>
            <p style={{ height: "100%" }}></p>
          </div>

          <div className={classes.Body} >
            {loading}
            {cardFormArray.map(formElement => {
              return (
                <Input
                  key={formElement.id}
                  label={formElement.config.label}
                  elementType={formElement.config.elementType}
                  elementConfig={formElement.config.elementConfig}
                  value={formElement.config.value}
                  extraClass={formElement.config.extraClass}
                  extraAction={formElement.config.extraAction}
                  loading={formElement.config.loading}
                  changed={(event) => this.inputChangedHandler(event, formElement.id)} />
              );
            })}

          </div>

          {loading}

          <div className={classes.Footer}>

            <div className={classes.FooterButtons}>
              {footerButtons}
            </div>
          </div>
        </Aux>
      );
    }

    let carrierClass = classes.CardModal;
    if (this.props.tripleMode) {
      carrierClass = classes.TrippleCardModal;
    } else if (this.props.sideBySideMode && (this.state.showCarrier || this.state.showTelegram)) {
      carrierClass = classes.FullCardModal;
    }

    return (
      <Aux>
        <Backdrop show={show} clicked={this.props.closeCard} />
        <div
          className={carrierClass}
          style={{
            transform: show ? 'translateY(0)' : 'translateY(-100vh)',
            opacity: show ? '1' : '0'
          }}>
          {card}
        </div>
      </Aux>
    );
  }
};

const mapStateToProps = state => {
  return {
    access_token: state.access_token,
    notifications: state.notifications,
    carriers: state.carriers,
    managers: state.managers,
    requests: state.requests,
    cars: state.cars,
    users: state.users,
    drivers: state.drivers,
    routes: state.routes,
    locations: state.locations,
    sideBySideMode: state.sideBySideMode,
    tripleMode: state.tripleMode,
    role: state.role,
    selectedTrip: state.selectedTrip,
    codeToMessage: state.codeToMessage
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addNotification: (notification, notificationType) => dispatch({
      type: actionTypes.ADD_NOTIFICATION,
      notification: notification,
      notificationType: notificationType
    }),
    onSetRoutes: (routes) => dispatch({
      type: actionTypes.ROUTES,
      routes: routes
    }),
    onSetRequests: (requests) => dispatch({
      type: actionTypes.REQUESTS,
      requests: requests
    }),
    onSetCarriers: (carriers) => dispatch({
      type: actionTypes.SET_CARRIERS,
      carriers: carriers
    }),
    onSetUsers: (users) => dispatch({
      type: actionTypes.SET_USERS,
      users: users
    }),
    onSetCars: (cars) => dispatch({
      type: actionTypes.SET_CARS,
      cars: cars
    }),
    onSetDrivers: (drivers) => dispatch({
      type: actionTypes.SET_DRIVERS,
      drivers: drivers
    }),
    onSelectRequest: (selectedRequest) => dispatch({ type: actionTypes.SELECT_REQUEST, selectedRequest: selectedRequest }),
    onShowNewCarrier: (showNewCarrier) => dispatch({ type: actionTypes.SHOW_NEW_CARRIER, showNewCarrier: showNewCarrier }),
    onSetManagers: (managers) => dispatch({
      type: actionTypes.SET_MANAGERS,
      managers: managers
    }),
    onShowDriverForm: (showDriverForm, driver) => dispatch({
      type: actionTypes.SHOW_DRIVER_FORM,
      showDriverForm: showDriverForm,
      driver: driver
    }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TripModal);



// WEBPACK FOOTER //
// ./src/components/TripModal/TripModal.js